module.exports = __webpack_public_path__ + "static/milkshake-4a6cf67fa46adf8ddb1e602bbd51d08d.gif";